<template>
  <div class="QuestionBankList">
    <div class="tableFilter">
      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="课包分类:" prop="category">
          <el-select
              v-model="filter.category"
              filterable
              placeholder="请选择"
              style="width: 100px"
              @change="onSubmit"
          >
            <el-option
                v-for="item in productionTypeOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付费方式">
          <el-select
              style="width: 100px"
              v-model="filter.paymentMethod"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in payOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
              style="width: 100px"
              v-model="filter.states"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in productStatesOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架时间">
          <el-date-picker
              style="width: 220px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-input
              style="width: 150px"
              v-model="filter.keyword"
              placeholder="课包名称"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" @click="handleAddQuestionBank" plain
                   v-show="permissionCode.has('research:product:manager')"
        >发布课包
        </el-button>
      </div>
    </div>
    <XTable
        :api="getProductQuestionBankList"
        :state="productList"
        :columns="columns"
        :loading="isBack"
        :tableSize="tableSize"
        :maxHeight="maxHeight"
        :layout="layout"
    ></XTable>
  </div>
</template>

<script>
import {
  PAY_TYPE,
  PRODUCTION_STATES,
} from "@/utils/constants";
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import XTable from "@/components/XTable/index.vue";

export default {
  name: "QuestionBankList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    const productStatesOption = Object.keys(PRODUCTION_STATES).map((key) => {
      return {
        value: Number(key),
        label: PRODUCTION_STATES[key],
      };
    });
    const self = this;
    const columns = [
      {
        prop: "id",
        label: "课包编号",
      },
      {
        prop: "name",
        label: "课包名称",
      },
      {
        prop: "paymentMethod",
        label: "付费方式",
        render(h, scope) {
          return (
              <div>
                <span>{PAY_TYPE[scope.row.paymentMethod]}</span>
              </div>
          );
        },
      },
      {
        label: "销售价(元)",
        render(h, scope) {
          return (
              <div>
                <span>{self.price(scope.row.salePrice)}</span>
              </div>
          );
        },
      },
      {
        prop: "validityCustom",
        label: "有效期",
        render() {
          return (
              <div>
                <div class="textBox">永久有效</div>
              </div>
          );
        },
      },
      {
        label: "上架时间",
        render(h, scope) {
          return (
              <div>
                <span>{self.formatDate(scope.row.upperTime)}</span>
              </div>
          );
        },
      },
      {
        label: "下架时间",
        render(h, scope) {
          return (
              <div>
                <span>{self.formatDate(scope.row.downTime)}</span>
              </div>
          );
        },
      },
      {
        label: "销量",
        render(h, scope) {
          return <div>{(scope.row && scope.row.saleCount) || 0}</div>;
        },
      },
      {
        prop: "states",
        label: "状态",
        render(h, scope) {
          return (
              <div>
                <span>{PRODUCTION_STATES[scope.row.states]}</span>
              </div>
          );
        },
      },
    ];
    return {
      hasPagination: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      back: false,
      columns: [
        ...columns,
        {
          label: "操作",
          fixed: "right",
          width: 250,
          render: function (h, scope) {
            return (
                <div>
                  {scope.row.states === 1 && (
                      <el-button
                          onClick={() => {
                            self.handleDownProduct(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        下架
                      </el-button>
                  )}
                  {scope.row.states === 0 && (
                      <el-button
                          onClick={() => {
                            self.handleUpProduct(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        上架
                      </el-button>
                  )}
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      disabled={scope.row.states === 1}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      disabled={scope.row.states === 1}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          },
        },
      ],
      productionTypeOption: [
        {
          id: null,
          name: "全部",
        },
      ],
      productStatesOption: [
        {
          value: null,
          label: "全部",
        },
        ...productStatesOption,
      ],
      payOptions: [
        {
          value: null,
          label: "全部",
        },
        {
          value: 0,
          label: "免费学习",
        },
        {
          value: 1,
          label: "付费学习",
        },
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "productList",
      "productListLoading",
      "isBack",
    ]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.teachingCenter.productListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "productListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    this.productionTypeOption.push(...await this.getCachedProductCategoryList)
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getProductQuestionBankList",
      "deployProduct",
      "deleteProduct",
      "getCachedProductCategoryList",
    ]),
    ...mapMutations("teachingCenter", ["clearFilter"]),
    async handleAddQuestionBank() {
      await this.$router.push(
          {
            name: "AddQuestionBank",
            params: {
              type: "add",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    // 搜索
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getProductQuestionBankList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    //重置
    onReset() {
      this.clearFilter();
      this.getProductQuestionBankList({
        page: 1,
      });
    },
    price(val) {
      if (!val) {
        return 0;
      } else {
        return val / 100;
      }
    },
    async handleEdit(row) {
      localStorage.setItem("productDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddQuestionBank",
            params: {
              type: "edit",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    handleDelete(row) {
      this.$confirm("删除课包后不可找回,请确认是否继续删除!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deleteProduct({
              id: row.id,
            });
            await this.getProductQuestionBankList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    async handleDownProduct(row) {
      this.$confirm("请确认是否要下架该课包!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deployProduct({
              id: row.id,
              states: 0,
            });
            await this.getProductQuestionBankList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    async handleUpProduct(row) {
      this.$confirm("请确认是否要上架该课包!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deployProduct({
              id: row.id,
              states: 1,
            });
            await this.getProductQuestionBankList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.QuestionBankList {
  .tableFilter {
    padding-bottom: 10px;
  }

  .el-form-item {
    margin-right: 20px;
  }

  ::v-deep .el-range-separator {
    width: 20px !important;
  }
}
</style>
